var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"any-qr-code"},[_c('div',{staticStyle:{"text-align":"center","padding":"10px"}},[_c('qr-canvas',{staticStyle:{"margin":"0 auto","max-width":"calc(100vw - 100px)"},attrs:{"options":_vm.options}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }